var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, NgModule, Input, Directive, ContentChild, ChangeDetectionStrategy, ChangeDetectorRef, HostBinding } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ThemeModule, IsBoolean, toBoolean } from 'alyle-ui/core';
import { LyInputContents } from './input-contents';
import { LyFieldDirective } from './ly-field.directive';
import { LyTheme, LyStyleTheme } from 'alyle-ui/core';
var LyInputCommon = /** @class */ (function () {
    function LyInputCommon() {
    }
    LyInputCommon.decorators = [
        { type: Directive, args: [{
                    selector: 'ly-default, ly-before, ly-after, ly-input ly-error, ly-input ly-hint'
                },] },
    ];
    /** @nocollapse */
    LyInputCommon.ctorParameters = function () { return []; };
    return LyInputCommon;
}());
export { LyInputCommon };
var LyPlaceholder = /** @class */ (function () {
    function LyPlaceholder() {
    }
    LyPlaceholder.decorators = [
        { type: Directive, args: [{
                    selector: 'ly-placeholder'
                },] },
    ];
    /** @nocollapse */
    LyPlaceholder.ctorParameters = function () { return []; };
    return LyPlaceholder;
}());
export { LyPlaceholder };
var LyDefault = /** @class */ (function () {
    function LyDefault() {
    }
    LyDefault.decorators = [
        { type: Directive, args: [{
                    selector: 'ly-default'
                },] },
    ];
    /** @nocollapse */
    LyDefault.ctorParameters = function () { return []; };
    return LyDefault;
}());
export { LyDefault };
var LyLabel = /** @class */ (function () {
    function LyLabel() {
    }
    LyLabel.decorators = [
        { type: Directive, args: [{
                    selector: 'ly-label'
                },] },
    ];
    /** @nocollapse */
    LyLabel.ctorParameters = function () { return []; };
    return LyLabel;
}());
export { LyLabel };
var LyInput = /** @class */ (function () {
    function LyInput(theme, styleTheme, _changeDetectorRef) {
        // this.paletteSubscription = this.theme.palette.subscribe((palette) => {
        //   this._inputColor = this.theme.colorOf(this._color);
        // });
        this.theme = theme;
        this.styleTheme = styleTheme;
        this._changeDetectorRef = _changeDetectorRef;
        this._color = 'primary';
        this._inputColor = 'primary';
        this.changed = new Array();
        this.touched = new Array();
        this.type = 'text';
    }
    Object.defineProperty(LyInput.prototype, "isFloatingLabel", {
        get: function () {
            return this.currentValueState || this.labelAbove || this.isDefault || this.focusState;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LyInput.prototype, "placeholderState", {
        get: function () {
            return !this.currentValueState && this.focusState || !this.currentValueState && !this.focusState && this.isFloatingLabel;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LyInput.prototype, "inputColor", {
        get: function () {
            return this._inputColor;
        },
        set: /**
           * inputColor
           */
        function (val) {
            // this._color = val;
            if (val) {
                this._inputColor = val;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LyInput.prototype, "defaultOff", {
        get: function () {
            return this.currentValue === this.default && !this.focusState || !this.currentValueState && !this.focusState;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LyInput.prototype, "disabled", {
        get: function () { return this._field.disabled; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LyInput.prototype, "required", {
        get: function () { return this._field.required; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LyInput.prototype, "currentValueState", {
        get: function () {
            return ("" + this.currentValue).length !== 0 && this.currentValue != null;
        },
        enumerable: true,
        configurable: true
    });
    LyInput.prototype._valueBoolean = function (val) {
        return !(val === null || val === undefined || val === false || val === '');
    };
    LyInput.prototype._isErrorState = function () {
        if (this._field) {
            return this._field._ngControl.invalid && this._field._ngControl.touched || this._errorState;
        }
    };
    LyInput.prototype.updateError = function () {
        this._errorState = this._field._ngControl.invalid;
    };
    LyInput.prototype.value = function () {
        return this.currentValue;
    };
    LyInput.prototype.toBoolean = function (val) {
        return toBoolean(val);
    };
    Object.defineProperty(LyInput.prototype, "isPlaceholder", {
        get: function () {
            return toBoolean(this.placeholder) || !!this.lyPlaceholder;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LyInput.prototype, "isDefault", {
        get: function () {
            return toBoolean(this.default) || !!this.lyDefault;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LyInput.prototype, "isLabel", {
        get: function () {
            return toBoolean(this.label) || !!this.lyLabel;
        },
        enumerable: true,
        configurable: true
    });
    LyInput.prototype.ngOnInit = function () {
        var _this = this;
        // this._inputColor = this.theme.colorOf(this._color);
        this.focusStateSuscription = this._field.focusState.subscribe(function (fState) {
            _this.focusState = fState;
        });
        if (this._field._parent()) {
            this._field._parent().ngSubmit.subscribe(function (submit) {
                _this.updateError();
            });
        }
    };
    LyInput.prototype.ngAfterViewInit = function () {
    };
    LyInput.prototype.ngAfterContentInit = function () {
        var _this = this;
        if (this._field) {
            this.currentValue = this._field._ngControl.value;
            if (this._field._ngControl && this._field._ngControl.valueChanges) {
                this._field._ngControl.valueChanges.subscribe(function (val) {
                    _this.currentValue = val;
                    _this._errorState = false;
                    _this._changeDetectorRef.markForCheck();
                    /**
                               * reset error of submit to false
                               */
                });
            }
            this._field.focusState.subscribe(function (isFocused) {
                if (_this.isDefault) {
                    if (!_this.currentValueState) {
                        _this.currentValue = _this.default;
                        _this._field._ngControl.valueAccessor.writeValue(_this.default);
                        _this._field._ngControl.viewToModelUpdate(_this.default);
                    }
                }
                _this._field.markForCheck();
                _this._changeDetectorRef.markForCheck();
            });
        }
        else {
            console.warn('LyInput: Require input native');
        }
    };
    LyInput.prototype._shouldForward = function (prop) {
        var control = this._field ? this._field._ngControl : null;
        return control && control[prop];
    };
    LyInput.prototype.ngOnChanges = function (changes) {
        if (changes.default) {
            if (this.isDefault && !this.currentValueState) {
                this.currentValue = this.default;
                this._field._ngControl.viewToModelUpdate(this.default);
            }
        }
    };
    LyInput.prototype.ngOnDestroy = function () {
        this.focusStateSuscription.unsubscribe();
    };
    LyInput.decorators = [
        { type: Component, args: [{
                    selector: 'ly-text-field, ly-input, ly-textarea',
                    styles: [":host { display: inline-block; position: relative; align-items: center; } :host /deep/ ly-before, :host /deep/ ly-after { display: inline-block; vertical-align: inherit; } :host /deep/ input, :host /deep/ textarea { border: none; outline: none; font-family: inherit; color: inherit; background: transparent; font-size: inherit; width: 100%; font-weight: 400; padding: 0; display: inline-flex; } :host.ly-hidden-input /deep/ .ly-input-container input, :host.ly-hidden-input /deep/ .ly-input-container textarea, :host.ly-default-off .ly-input-default { opacity: 0; } /** * Focus Input **/ :host.ly-focus-active .ly-input-underline:after { width: 100%; } :host.ly-focus-active .ly-input-top-label, :host.ly-focus-active /deep/ ly-top-label { font-size: 75%; top: 0; transform: translate(0, 0); } :host.ly-focus-active .ly-input-default { opacity: 0; } :host.ly-value-on .ly-input-placeholder { opacity: 0; } .ly-input-underline { position: absolute; bottom: 0.875em; height: 1px; right: 0; left: 0; } .ly-input-underline:after { content: ''; position: absolute; width: 0%; height: 2px; background: currentColor; left: 0; right: 0; margin: 0 auto; bottom: 0; transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms; } .ly-input-underline.ly-disabled { background: transparent; background-image: linear-gradient(to right, #b4b4b4 0%, #b4b4b4 33%, transparent 0%); background-size: 4px 1px; background-repeat: repeat-x; border-top: 0; background-position: 0; } .ly-input-underline.ly-disabled:after { width: 0%; } :host.ly-label-above .ly-input-float-label { font-size: 75%; top: 0; } /** * ly-label(placeholder) */ .ly-input-placeholder, .ly-input-default, .ly-input-float-label { pointer-events: none; position: absolute; bottom: 1.125em; top: 1.125em; margin: auto; font-size: 100%; transition: all 375ms cubic-bezier(0.23, 1, 0.32, 1); color: inherit; width: 100%; } .ly-input-content { width: 100%; position: relative; display: flex; } .ly-input-container { padding: 1.125em 0; position: relative; opacity: 1; display: inline-block; vertical-align: inherit; width: 100%; } .ly-input-container ::ng-deep input { text-align: inherit; } .bottom-field, .ly-error-container { position: absolute; bottom: 0; left: 0; width: 100%; pointer-events: none; font-size: 75%; transform: translate3d(0, calc(100% - 1.1em), 0); display: flex; } .bottom-field .bottom-field-space, .ly-error-container .bottom-field-space { flex: 1; } .ly-required { position: absolute; top: 1.125em; right: 0; pointer-events: none; transform: translate3d(0, 0, 0); opacity: 0.45; } :host.ly-input-invalid .ly-input-underline, :host.ly-input-invalid .ly-input-placeholder, :host.ly-input-invalid /deep/ ly-error, :host.ly-input-invalid .ly-input-float-label { color: #F44336 !important; } :host.ly-input-invalid .ly-input-underline:after { width: 100%; } .ly-input-content { color: currentColor; } "],
                    template: "<ng-content select=\"ly-before\"></ng-content> <div class=\"ly-input-underline\" [color]=\"inputColor\" bg=\"input:underline\"></div> <div class=\"ly-input-container\"> <ng-content select=\"input, textarea\"></ng-content> <!-- ly-placeholder --> <ng-container *ngIf=\"placeholder; then isPlaceholderTemplate; else placeholderContainer\"></ng-container> <ng-template #isPlaceholderTemplate> <div *ngIf=\"toBoolean(placeholder) !== undefined && placeholderState\" color=\"input:label\" class=\"ly-input-placeholder\">{{ placeholder }}</div> </ng-template> <ng-template #placeholderContainer> <div *ngIf=\"lyPlaceholder !== undefined && placeholderState\" color=\"input:label\" class=\"ly-input-placeholder\"> <ng-content select=\"ly-placeholder\"></ng-content> </div> </ng-template> <!-- ly-default --> <ng-container *ngIf=\"toBoolean(default); then isDefaultTemplate\"></ng-container> <ng-template #isDefaultTemplate> <div *ngIf=\"!(lyDefault !== undefined) && defaultOff\" color=\"input:label\" class=\"ly-input-default\">Default: {{ default }}</div> <div *ngIf=\"lyDefault !== undefined && defaultOff\" color=\"input:label\" class=\"ly-input-default\"> <ng-content select=\"ly-default\"></ng-content>{{ default }} </div> </ng-template> <!-- ly-label --> <ng-container *ngIf=\"toBoolean(label); then _isLabelTemplate; else labelContainer\"></ng-container> <ng-template #_isLabelTemplate> <div *ngIf=\"label !== undefined\" color=\"input:label\" class=\"ly-input-float-label\">{{ label }}</div> </ng-template> <ng-template #labelContainer> <div *ngIf=\"lyLabel\" color=\"input:label\" class=\"ly-input-float-label\"> <ng-content select=\"ly-label\"></ng-content> </div> </ng-template> </div> <div class=\"ly-icon-required\" *ngIf=\"required\"></div> <div class=\"bottom-field\" *ngIf=\"!_isErrorState()\"> <ng-content select=\"ly-hint[align=start], ly-hint:not(ly-hint[align])\"></ng-content> <span class=\"bottom-field-space\"></span> <ng-content select=\"ly-hint[align=end]\"></ng-content> </div> <div class=\"bottom-field\" *ngIf=\"_isErrorState()\"> <ng-content select=\"ly-error\"></ng-content> </div> <ng-content select=\"ly-after\"></ng-content> ",
                    // tslint:disable-next-line:use-host-property-decorator
                    host: {
                        '[class.ly-input-invalid]': '_isErrorState()',
                        '[class.ng-untouched]': '_shouldForward("untouched")',
                        '[class.ng-touched]': '_shouldForward("touched")',
                        '[class.ng-pristine]': '_shouldForward("pristine")',
                        '[class.ng-dirty]': '_shouldForward("dirty")',
                        '[class.ng-valid]': '_shouldForward("valid")',
                        '[class.ng-invalid]': '_shouldForward("invalid")',
                        '[class.ng-pending]': '_shouldForward("pending")',
                    },
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    preserveWhitespaces: false
                },] },
    ];
    /** @nocollapse */
    LyInput.ctorParameters = function () { return [
        { type: LyTheme, },
        { type: LyStyleTheme, },
        { type: ChangeDetectorRef, },
    ]; };
    LyInput.propDecorators = {
        "_field": [{ type: ContentChild, args: [LyFieldDirective,] },],
        "lyPlaceholder": [{ type: ContentChild, args: [LyPlaceholder,] },],
        "lyDefault": [{ type: ContentChild, args: [LyDefault,] },],
        "lyLabel": [{ type: ContentChild, args: [LyLabel,] },],
        "type": [{ type: Input },],
        "label": [{ type: Input },],
        "placeholder": [{ type: Input },],
        "labelAbove": [{ type: Input },],
        "default": [{ type: Input },],
        "isFloatingLabel": [{ type: HostBinding, args: ['class.ly-label-above',] },],
        "inputColor": [{ type: Input, args: ['inputColor',] },],
        "focusState": [{ type: HostBinding, args: ['class.ly-focus-active',] },],
        "defaultOff": [{ type: HostBinding, args: ['class.ly-hidden-input',] },],
        "disabled": [{ type: Input },],
        "required": [{ type: Input },],
        "currentValueState": [{ type: HostBinding, args: ['class.ly-value-on',] },],
    };
    __decorate([
        IsBoolean(),
        __metadata("design:type", Boolean)
    ], LyInput.prototype, "labelAbove", void 0);
    return LyInput;
}());
export { LyInput };
var LyInputModule = /** @class */ (function () {
    function LyInputModule() {
    }
    LyInputModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, FormsModule, ThemeModule],
                    exports: [LyInput, LyInputContents, LyFieldDirective, LyInputCommon, LyDefault, LyLabel, LyPlaceholder],
                    declarations: [LyInput, LyInputContents, LyFieldDirective, LyInputCommon, LyDefault, LyLabel, LyPlaceholder],
                },] },
    ];
    /** @nocollapse */
    LyInputModule.ctorParameters = function () { return []; };
    return LyInputModule;
}());
export { LyInputModule };
//# sourceMappingURL=input.js.map